<template>
  <v-card outlined class="mx-auto">
    <v-card-title>
      <h3>{{ $t("settings.FirstInteractionAskEmail.title") }}</h3>
    </v-card-title>
    <v-card-text>
      <v-row justify="center" align="center">
        <v-col cols="auto">
          <v-checkbox
            v-model="checkbox"
            @change="saveConfig"
            :label="$t('settings.FirstInteractionAskEmail.body')"
            :hint="$t('settings.FirstInteractionAskEmail.tooltip')"
            persistent-hint
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "FirstInteractionAskEmail",
  data: () => ({
    checkbox: false,
  }),
  computed: {
    config() {
      return this.$store.state.store_config.store.chat_config;
    },
  },
  async mounted() {
    console.log(this.config);
    this.checkbox = this.config?.first_interaction_ask_email || false;
  },
  methods: {
    async saveConfig() {
      try {
        //check if config.first_interaction_ask_email is already set to this.checkbox
        if (this.config.first_interaction_ask_email === this.checkbox) return;
        const confirmation = await this.$store.dispatch("confirmer/ask", {
          title: this.$t("show_box.title"),
          body: `Do you confirm ?`,
          ligth: false,
        });
        if (!confirmation) {
          this.checkbox = !this.checkbox;
          return;
        }
        this.config.first_interaction_ask_email = this.checkbox;
        // console.log("saveConfig", this.checkbox, this.config);
        const new_config = await this.$store.dispatch("UPDATE_CHAT_CONFIG", {
          chat_config: this.config,
        });
        if (new_config) {
          this.$socket.emit("UPDATE_CHAT_CONFIG_SOCKET", new_config);
        }
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: this.$t("settings.FirstInteractionAskEmail.success"),
          color: "success",
          timeout: 2000,
        });
      } catch (error) {
        console.log("error", error);
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: this.$t("settings.FirstInteractionAskEmail.error"),
          color: "error",
          timeout: 2000,
        });
      }
    },
  },
};
</script>
